import { Session, session } from '../api'
import { useQuery } from '@tanstack/react-query'

export const useClientSession = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['userSession'],
    queryFn: async () => await session(),
    refetchInterval: 10000,
    retry: 5
  })

  return {
    data,
    isAuthenticated: !!data?.accessToken,
    isLoading,
    error,
    refetch
  }
}
